import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { Box, Button } from "@mui/material";

import { APP_V2_USER_EVENTS, logEvent } from "../lib/analytics";
import { FACILITY_HELP_SUPPORT_LINK } from "./paths";

export function ExternalHelpCenterLinkButton() {
  return (
    <Box>
      <Button
        component="a"
        href={FACILITY_HELP_SUPPORT_LINK}
        target="_blank"
        rel="noopener noreferrer"
        variant="outlined"
        startIcon={<OpenInNewOutlinedIcon />}
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.HELP_CENTER_EXTERNAL_LINK_CLICKED);
        }}
      >
        Check out more articles
      </Button>
    </Box>
  );
}
